/**
 * Простые якорные ссылки с плавным скроллом
 */

class Anchor {
    constructor(el) {
        this.$link = $(el);

        this.init();
    }

    init() {
        this.$link.on('click', (e) => {
            e.preventDefault();

            let top;
            const href = this.$link.attr('href').substr(1);

            try {
                top = $(`[data-id="${href}"]`).offset().top - 70;
            } catch (error) {
                return false;
            }

            $('html, body').animate({
                scrollTop: top
            }, 600);
        });
    }
}


$('.js-anchor').each(function() {
    new Anchor(this);
});



// WEBPACK FOOTER //
// ./_src/js/modules/Anchor.js